import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import { AppLayout } from "./components/layout/AppLayout";
import { SessionCalendar } from "./pages/SessionCalendar";
import { SessionDetail } from "./pages/SessionDetail";
import { UserManagement } from "./pages/UserManagement";
import { BadDebts } from "./pages/BadDebts";
import { TestLoader } from "./pages/TestLoader";
import { AuthCallback } from "./pages/AuthCallback";

import { AuthProvider } from "./AuthProvider";
import { LanguageProvider } from "./LanguageProvider";
import { AdminProvider } from "./AdminProvider";

import "./App.css";

function App() {
  return (
    <Router>
      <LanguageProvider>
        <AdminProvider>
          <AuthProvider>
            <Toaster position="top-right" />
            <Routes>
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/" element={<AppLayout />}>
                <Route index element={<SessionCalendar />} />
                <Route path="sessions/:id" element={<SessionDetail />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="debts" element={<BadDebts />} />
                <Route path="test-loader" element={<TestLoader />} />
              </Route>
            </Routes>
          </AuthProvider>
        </AdminProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
